import { DecisionBadge, EmptyState, RuleResult, normDecision } from "@/sentinel";

// Thin adapters kept so older call sites keep working. New code imports from "@/sentinel" directly.

/** A decision in the six-value vocabulary. `muted` for every decision except the screen's current one. */
export function DecisionPill({ label, size = "md", muted = false, testId = "decision-pill" }) {
  if (!label) return <span className="sn-small sn-faint" data-testid={testId}>—</span>;
  return <DecisionBadge decision={normDecision(label)} size={size === "sm" ? "compact" : "standard"} muted={muted} data-testid={testId} />;
}

/** A rule outcome: glyph + mono label, prefixed by the rule ID. */
export function RuleBadge({ code, value }) {
  return (
    <RuleResult result={value} data-testid={`rule-${code}`} title={code}>
      {code} {String(value || "NA").toUpperCase()}
    </RuleResult>
  );
}

export function Empty({ children, testId, title = "Nothing to show yet", icon = "Layers" }) {
  return <EmptyState icon={icon} title={title} data-testid={testId}>{children}</EmptyState>;
}
